// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Plus: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 30 31" enableBackground="new 0 0 30 31" xmlSpace="preserve">
<polygon fillRule="evenodd" clipRule="evenodd" points="18,12.25 18,0.25 12,0.25 12,12.25 0,12.25 0,18.25 12,18.25 12,30.25 
	18,30.25 18,18.25 30,18.25 30,12.25 "/>
</svg>;
};

export default React.memo(Plus);
